module.exports = __webpack_public_path__ + "media/packs/images/details/location-3877d042d6732d7acd81466fd086e4c4.svg";